import type { Separator as SeparatorType } from "@repo/fetch-repository/settings";
import { useTranslations } from "next-intl";
import { Banner } from "../../nodes/banner";
import { CatalogsCarouselWithBanner } from "./catalogs-carousel-with-banner";

export function Separator(props: {
  separator: SeparatorType;
  banner: { marginTop: string; marginBottom: string };
}): React.JSX.Element {
  const t = useTranslations();
  return props.separator.type === "catalog" && props.separator.catalogs ? (
    <CatalogsCarouselWithBanner
      banner={
        props.separator.cover.data?.length
          ? props.separator.cover.data[0]?.url
          : props.separator.cover.data?.url || ""
      }
      catalogs={props.separator.catalogs}
      download={t("catalogsCarouselWithBanner.download")}
      marginBottom={props.banner.marginBottom}
      marginTop={props.banner.marginTop}
      view={t("catalogsCarouselWithBanner.view")}
    />
  ) : (
    <Banner
      backgroundImage={
        props.separator.cover.data?.length
          ? props.separator.cover.data[0]?.url
          : props.separator.cover.data?.url || ""
      }
      marginBottom={props.banner.marginBottom}
      marginTop={props.banner.marginTop}
    >
      <div className="web-text-white web-py-10 md:web-py-20 web-flex web-flex-col">
        <h1 className="web-font-helvetica rtl:web-font-doran web-text-[18px] md:web-text-[30px] lg:web-text-[40px] lg:web-font-[100] rtl:lg:web-font-bold">
          {props.separator.title}
        </h1>
        <p className="web-font-helvetica rtl:web-font-doran lg:web-text-[23px] web-text-[16px] md:web-text-[18px]">
          {props.separator.description}
        </p>
      </div>
    </Banner>
  );
}
